import { router, usePage } from '@inertiajs/react'
import { ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface SharedProps {
  impersonating: boolean
  stop_impersonation_url: string
  [key: string]: unknown
}

export function ImpersonationBanner() {
  const { impersonating, stop_impersonation_url } = usePage<SharedProps>().props

  if (!impersonating) return null

  function handleStop() {
    router.delete(stop_impersonation_url)
  }

  return (
    <div className="flex items-center justify-between gap-4 bg-destructive px-4 py-2 text-destructive-foreground text-sm">
      <div className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <span>You are currently impersonating another user.</span>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={handleStop}
        className="border-destructive-foreground/30 text-destructive-foreground hover:bg-destructive-foreground/10"
      >
        Stop impersonating
      </Button>
    </div>
  )
}
